import {
  Component,
  Input,
  Output,
  ElementRef,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DataService } from '../../services/data.service'
import { isBoolean } from "util";
import { environment } from "../../../../environments/environment";
@Component({
  selector: "app-report-viewer",
  templateUrl: "./report-viewer.component.html",
  styleUrls: ["./report-viewer.component.css"]
})
export class ReportViewerComponent implements OnChanges {
  @Input() reporturl: string;
  @Input() reportserver: string;
  @Input() showparameters?: string = "false";
  @Input() parameters?: any;
  @Input() language?: string = "en-us";
  @Input() width?: number = 100;
  @Input() height?: number = 100;
  @Input() toolbar?: string = "true";

  @Output("error") onError = new EventEmitter<any>();
  constructor(private sanitizer: DomSanitizer, private ds: DataService) { }

  source: SafeResourceUrl;

  ngOnChanges(changes: SimpleChanges) {

    if (!this.reporturl) {
      this.onError.emit("Src cannot be null");
    }

    if ("reporturl" in changes) {
      this.source = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.buildReportUrl()
      );
    }
  }

  public buildParameterString(): string {
    var parameterString = "";

    for (var param in this.parameters) {
      if (param) {
        if (this.parameters[param] instanceof Array === true) {
          for (var arrayParam in this.parameters[param]) {
            if (arrayParam) {
              parameterString +=
                "&" + param + "=" + this.parameters[param][arrayParam];
            }
          }
        }
        if (
          this.parameters[param] != null &&
          this.parameters[param] instanceof Array === false
        ) {
          parameterString += "&" + param + "=" + this.parameters[param];
        }
        if (this.parameters[param] == null) {
          parameterString += "&" + param + ":isnull=true";
        }
      }
    }
    return parameterString;
  }

  public buildReportUrl(): string {

    if (!this.reporturl) {

      return;
    }
    if (this.reporturl.startsWith('https://')) {
      return this.reporturl;
    }
    var parameters = this.buildParameterString();
    //var url = "http://localhost:27942/offlineRpt.aspx";
    //var url1 = "http://localhost:27942/offlineRpt.aspx";
    //var url2 = "http://91.74.11.226:4444/SSRS/Reports.aspx";
    var inrpt = environment.SSRSReportUrl;//this.ds.Settings.WebReortPath;
    //inrpt = "http://localhost:27942"
    if (this.ds.Settings.InBuildReport == "True") {
      inrpt += "/offlineRpt.aspx"
    } else {
      inrpt += "/Reports.aspx"
    }
    return (
      inrpt +
      "?" +
      "baseUrl=" + this.ds.Settings.ReportServerPath +
      "&reporturl=/" +
      this.reporturl +
      parameters
    );
  }
  public buildReportUrl1(): string {
    if (!this.reporturl) {
      return;
    }
    var parameters = this.buildParameterString();
    return (
      this.reportserver +
      "?/" +
      this.reporturl +
      "&rs:Embed=true" +
      "&rc:Parameters=" +
      this.showparameters +
      parameters +
      "&rs:ParameterLanguage=" +
      this.language +
      "&rc:Toolbar=" +
      this.toolbar
    );
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/report-viewer/report-viewer.component.ts